export const SidebarData = [
    {
        title: "Events",
        path:  "/admin/events",
        icon:  "bi bi-calendar",
    },
    {
        title: "Claims",
        path: "/admin/claims",
        icon: "bi bi-pen"
    },
    {
        title: "Countries",
        path: "/admin/countries",
        icon: "bi bi-flag"
    },
    {
        title: "Distance Bands",
        path: "/admin/distances",
        icon: "bi bi-signpost"
    },
    {
        title: "Employees",
        "path": "/admin/contacts",
        "icon": "bi bi-person-fill"
    }
]